import { IconRegistryService } from './icon-registry.service';

import {
  Input,
  ChangeDetectionStrategy,
  Component,
  Optional,
  Inject,
  ElementRef,
  DOCUMENT
} from '@angular/core';
import { AnimalSymbol } from 'src/app/calendar/shared/models/animal-symbol.enum';

@Component({
    selector: 'diana-icon',
    template: `
    <div
      class="icon-wrap"
      [ngStyle]="{
        color: color,
        width: width,
        height: height,
        display: display
      }"
    ></div>
  `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class IconComponent {
  private svgIcon?: SVGElement;

  @Input()
  color: string = '#fff';

  @Input()
  width: string = '24px';

  @Input()
  height: string = '24px';

  @Input()
  display: string = 'flex';

  @Input()
  set name(iconSymbol: number | undefined) {
    const iconName = this.checkValidSymbolName(iconSymbol);
    if (this.svgIcon) {
      this.element.nativeElement.childNodes[0].removeChild(this.svgIcon);
    }
    const svgData = this.myIconsRegistry.getIcon(iconName);
    if (!svgData) {
      // Silent fail. Text will be displayed instead of the icon
      const spanEl = this.document.createElement('SPAN');
      spanEl.innerHTML = iconName ? `(${iconName})` : '';
      this.element.nativeElement.appendChild(spanEl);
      return;
    }

    this.svgIcon = this.svgElementFromString(svgData);
    const targetContainer = this.element.nativeElement.childNodes[0];
    targetContainer.appendChild(this.svgIcon);
  }

  constructor(
    private element: ElementRef,
    private myIconsRegistry: IconRegistryService,
    @Optional() @Inject(DOCUMENT) private document: any
  ) {}

  private checkValidSymbolName(currentSymbol: number | undefined): string {
    const animalSymbosKeys = Object.keys(AnimalSymbol);
    let animalSymbol = 'multi'
    animalSymbosKeys.map(animalSymbolText => {
      const symbolNumber = Number(animalSymbolText);
      if (symbolNumber === currentSymbol) {
        animalSymbol = AnimalSymbol[currentSymbol];
      }
    });

    return animalSymbol;
  }

  private svgElementFromString(svgContent: string): SVGElement {
    const div = this.document.createElement('DIV');
    div.innerHTML = svgContent;
    return (
      div.querySelector('svg') ||
      this.document.createElementNS('http://www.w3.org/2000/svg', 'path')
    );
  }
}
